export const ToothIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C9.5 2 7 3.5 7 6c0 1.5.5 2.5 1 4 .5 1.5 1 3.5 1 5 0 2.5 1 5 3 5s3-2.5 3-5c0-1.5.5-3.5 1-5 .5-1.5 1-2.5 1-4 0-2.5-2.5-4-5-4z"/>
    <path d="M9 6c0 1 1.5 2 3 2s3-1 3-2"/>
  </svg>
);
